export const timeLineArr = [
  {
    category: "Booking Status",
    name: "Booked",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  // {
  //   category: "Booking Status",
  //   name: "Awaiting for Garage/ Driver mapping",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },
  // {
  //   category: "Booking Status",
  //   name: "Confirmed",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },

  // {
  //   category: "Pick Status",
  //   name: "Pickup Scheduled",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },
  {
    category: "Pick Status",
    name: "Picked Up",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  // {
  //   category: "Pick Status",
  //   name: "Dropped at Garage",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },

  {
    category: "Work Status",
    name: "Estimate",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Work-In-Progress",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Spares-Pending",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Ready for Delivery",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Invoice",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Payment Pending",
    updatedAt: "2021-02-15T20:55:23Z",
  },
  {
    category: "Work Status",
    name: "Delivered",
    updatedAt: "2021-02-15T20:55:23Z",
  },

  // {
  //   category: "Drop Status",
  //   name: "Pickup Scheduled",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },
  // {
  //   category: "Drop Status",
  //   name: "Picked Up",
  //   updatedAt: "2021-02-15T20:55:23Z",
  // },
  {
    category: "Drop Status",
    name: "Dropped at your location",
    updatedAt: "2021-02-15T20:55:23Z",
  },
];
